import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { sendContactEmail } from '../../../services/emailService';
import './ContactPage.css';

const WHATSAPP_NUMBER = '254725115550'; // without +
const WHATSAPP_BASE   = `https://wa.me/${WHATSAPP_NUMBER}`;

function buildWhatsAppLink(message = '') {
  const text = message
    ? encodeURIComponent(message)
    : encodeURIComponent('Hi! I have a question about Fagierrands.');
  return `${WHATSAPP_BASE}?text=${text}`;
}

const SUBJECTS = [
  'General Enquiry',
  'Order Support',
  'Billing / Payment',
  'Partnership / Business',
  'App Feedback',
  'Other',
];

const INITIAL_FORM = { name: '', email: '', subject: SUBJECTS[0], message: '' };

export default function ContactPage() {
  const [form, setForm]       = useState(INITIAL_FORM);
  const [status, setStatus]   = useState(null); // { type: 'success'|'error', text: string }
  const [sending, setSending] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus(null);

    const result = await sendContactEmail(form);

    setStatus({ type: result.success ? 'success' : 'error', text: result.message });
    if (result.success) {
      setForm(INITIAL_FORM);
    }
    setSending(false);
  };

  const whatsappLink = buildWhatsAppLink(
    form.message
      ? `Hi! My name is ${form.name}. ${form.message}`
      : ''
  );

  return (
    <div className="cp-page">
      {/* ── Hero ── */}
      <header className="cp-hero">
        <div className="cp-hero-inner">
          <h1 className="cp-hero-title">Get in Touch</h1>
          <p className="cp-hero-sub">
            We're available 24/7 — reach us by email, phone, or WhatsApp.
          </p>
        </div>
      </header>

      <main className="cp-main">
        <div className="cp-grid">

          {/* ── Contact info panel ── */}
          <aside className="cp-card cp-info">
            <h2 className="cp-section-title">Contact Info</h2>

            <ul className="cp-info-list">
              <li className="cp-info-item">
                <span className="cp-info-icon" aria-hidden="true">📞</span>
                <div>
                  <span className="cp-info-label">Phone / WhatsApp</span>
                  <a href="tel:+254725115550" className="cp-info-value">+254 725 115 550</a>
                </div>
              </li>

              <li className="cp-info-item">
                <span className="cp-info-icon" aria-hidden="true">✉️</span>
                <div>
                  <span className="cp-info-label">Support Email</span>
                  <a href="mailto:support@fagierrands.com" className="cp-info-value">
                    support@fagierrands.com
                  </a>
                </div>
              </li>

              <li className="cp-info-item">
                <span className="cp-info-icon" aria-hidden="true">📍</span>
                <div>
                  <span className="cp-info-label">Office</span>
                  <span className="cp-info-value">
                    Next Gen Mall, Mombasa Road, 3rd Floor, Nairobi, Kenya
                  </span>
                </div>
              </li>

              <li className="cp-info-item">
                <span className="cp-info-icon" aria-hidden="true">🕐</span>
                <div>
                  <span className="cp-info-label">Support Hours</span>
                  <span className="cp-info-value">24 / 7</span>
                </div>
              </li>
            </ul>

            {/* WhatsApp CTA */}
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="cp-wa-btn"
              aria-label="Chat with us on WhatsApp"
            >
              <svg className="cp-wa-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              Chat on WhatsApp
            </a>

            {/* Legal links */}
            <div className="cp-legal">
              <p className="cp-legal-label">Legal information</p>
              <div className="cp-legal-links">
                <Link to="/privacy" className="cp-legal-link">Privacy Policy</Link>
                <Link to="/terms" className="cp-legal-link">Terms of Service</Link>
                <Link to="/how-to-delete-account" className="cp-legal-link">Delete Account</Link>
              </div>
            </div>
          </aside>

          {/* ── Contact form panel ── */}
          <section className="cp-card cp-form-card">
            <h2 className="cp-section-title">Send Us a Message</h2>
            <p className="cp-form-sub">
              We usually reply within a few hours. Fields marked * are required.
            </p>

            <form onSubmit={handleSubmit} className="cp-form" noValidate>
              <div className="cp-field-row">
                {/* Name */}
                <div className="cp-field">
                  <label htmlFor="cp-name" className="cp-label">Name *</label>
                  <input
                    id="cp-name"
                    name="name"
                    type="text"
                    autoComplete="name"
                    placeholder="Your full name"
                    value={form.name}
                    onChange={handleChange}
                    required
                    className="cp-input"
                  />
                </div>

                {/* Email */}
                <div className="cp-field">
                  <label htmlFor="cp-email" className="cp-label">Email *</label>
                  <input
                    id="cp-email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    placeholder="you@example.com"
                    value={form.email}
                    onChange={handleChange}
                    required
                    className="cp-input"
                  />
                </div>
              </div>

              {/* Subject */}
              <div className="cp-field">
                <label htmlFor="cp-subject" className="cp-label">Subject *</label>
                <select
                  id="cp-subject"
                  name="subject"
                  value={form.subject}
                  onChange={handleChange}
                  required
                  className="cp-input cp-select"
                >
                  {SUBJECTS.map((s) => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
              </div>

              {/* Message */}
              <div className="cp-field">
                <label htmlFor="cp-message" className="cp-label">Message *</label>
                <textarea
                  id="cp-message"
                  name="message"
                  rows={5}
                  placeholder="Tell us how we can help…"
                  value={form.message}
                  onChange={handleChange}
                  required
                  className="cp-input cp-textarea"
                />
              </div>

              {/* Status message */}
              {status && (
                <div
                  role="alert"
                  className={`cp-status ${status.type === 'success' ? 'cp-status--success' : 'cp-status--error'}`}
                >
                  {status.type === 'success' ? '✅ ' : '⚠️ '}{status.text}
                </div>
              )}

              {/* Submit + WhatsApp row */}
              <div className="cp-actions">
                <button
                  type="submit"
                  className="cp-btn cp-btn--primary"
                  disabled={sending}
                  aria-busy={sending}
                >
                  {sending ? (
                    <><span className="cp-spinner" aria-hidden="true" /> Sending…</>
                  ) : (
                    'Send Message'
                  )}
                </button>

                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cp-btn cp-btn--whatsapp"
                  aria-label="Send via WhatsApp instead"
                >
                  <svg className="cp-wa-icon-sm" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                  WhatsApp Instead
                </a>
              </div>
            </form>
          </section>

        </div>
      </main>
    </div>
  );
}
